import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_COMMENT = "listComments";
export const GET_DETAIL_COMMENT = "detailComment";
export const SAVE_COMMENT = "saveComments";
export const UPDATE_COMMENT = "updateComments";
export const DELETE_COMMENT = "deleteComments";
export const UPLOAD_COMMENT_IMAGE = "uploadComments";
export const GET_DATA_SEARCH = "getDataSearchComments";
export const SET_DATA_SEARCH = "setDataSearchComments";

export const SET_LIST_COMMENT = "setListComments";
export const SET_DETAIL_COMMENT = "setDetailComments";


const state = {
    comments: [],
    comment: {},
    dataSearch: []
};

const getters = {
    comments(state) {
        return state.comments;
    },
    commentDetail(state) {
        return state.comment;
    },

    dataSearchComment(state) {
        return state.dataSearch;
    },
};

const actions = {
    [GET_LIST_COMMENT](context, payload) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_COMMENT, payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_COMMENT, data);
                    context.commit(SET_DATA_SEARCH, data.data);
                }
                resolve(data);
            });
        });
    },

    [UPLOAD_COMMENT_IMAGE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.UPLOAD_COMMENT_IMAGE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },

    [GET_DATA_SEARCH](context, payload) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_COMMENT_SEARCH, payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DATA_SEARCH, data.data.product_comments);
                }
                resolve(data);
            });
        });
    },

    [GET_DETAIL_COMMENT](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_COMMENT}/${id}`).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DETAIL_COMMENT, data);
                }
                resolve(data);
            });
        });
    },

    [SAVE_COMMENT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_COMMENT}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_COMMENT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_COMMENT}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_COMMENT](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_COMMENT}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};

const mutations = {
    [SET_LIST_COMMENT](state, data) {
        state.comments =  data.data
    },
    [SET_DETAIL_COMMENT](state, data) {
        state.comment = data.data;
    },

    [SET_DATA_SEARCH](state, data) {
        state.dataSearch = data
    }

};

export default {
    state,
    actions,
    mutations,
    getters
};